import { render, staticRenderFns } from "./dist-add-or-update.vue?vue&type=template&id=12c3f92e&"
import script from "./dist-add-or-update.vue?vue&type=script&lang=js&"
export * from "./dist-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports